<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug">
</template>

<script>
export default {
  name: "wl-header",
  props: {
    title: {
      type: String,
      required: false,
    },
    isBack: {
      type: Boolean,
      required: false,
      default: true,
    },
    sticky: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {},
  data() {
    return {
      
    };
  },
  watch: {},
  computed: {},
  mounted() {},
  methods: {
    
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/wl-header/index.vue